import React, { Component } from "react";
import styles from "./Checkbox.scss";
import prettyCheckbox from "../../../assets/styles/pretty-checkbox/pretty-checkbox.scss";
import blueCheck from "../../../assets/images/checked-blue-x2.png";
import classnames from "classnames";

class Checkbox extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const checked = event.target.checked;
    if (this.props.onCheck) {
      this.props.onCheck(checked);
    }
    this.props.input.onChange(checked);
  }

  render() {
    const { input, formGroupClassName, text, isBig } = this.props;

    return (
      <div>
        <div
          className={classnames(
            prettyCheckbox.pretty,
            prettyCheckbox["p-image"],
            prettyCheckbox["p-curve"],
            prettyCheckbox["p-smooth"],
            formGroupClassName,
            styles.checkbox,
            {
              [styles.noMargin]: this.props.noMargin,
              [styles.signUp]: this.props.signUp,
              [styles.big]: isBig
            }
          )}
        >
          <input
            type="checkbox"
            name={name}
            checked={
              this.props.controlCheck ? this.props.isChecked : input.value
            }
            onChange={this.onChange}
            disabled={this.props.disabled}
          />

          <div
            className={classnames(
              prettyCheckbox.state,
              prettyCheckbox["p-primary-o"]
            )}
          >
            <img className="image" src={blueCheck} />
            <label className={styles.text}>{text}</label>
          </div>
        </div>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/checkbox/Checkbox.js